import {Load} from "./Load";
import {Podcastplayer} from "./Podcastplayer";

export class Observer
{
    constructor(el)
    {
        el.dataset.autoload = '';
        this.targetContainer = el;
        this.observer = new IntersectionObserver(this.load_more.bind(this));
        this.start_observing();
    }

    start_observing()
    {
        let lastChild = this.targetContainer;

        // if load container has sections get last tile from last section
        if(lastChild.querySelector('.w__module--tiles'))
        {
            lastChild = lastChild.querySelector('.w__module--tiles:last-child');
        }

        lastChild = lastChild.querySelector('.w__tile:last-child');

        this.observer.observe(lastChild);
    }

    load_more(e)
    {
        if(e[0].isIntersecting === true)
        {
            this.observer.unobserve(e[0].target);

            // get filter if available
            const activeFilter = document.body.querySelector(
                '.w__search--filter-cell .w__search--filter.active');

            // get search field if available
            const searchField = document.body.querySelector('.w__search--filter-cell .w__input--search');

            Load.post({
                f: 'load-more',
                filter: activeFilter ? activeFilter.dataset.filter : null,
                search: searchField ? searchField.value.trim() : null,
                target: this.targetContainer.dataset.target,
                start: parseInt(this.targetContainer.dataset.start)
            }).then(r => {
                switch(this.targetContainer.dataset.target)
                {
                    case 'news':
                        this.insert_news(r);
                        break;

                    default:
                        this.insert_tiles(r['tiles']);
                        // initialize Podcast player
                        const podcasts = document.body.querySelectorAll('.w__podcast--container:not(.initialized)');
                        for(let i=0; i<podcasts.length; i++)
                        {
                            podcasts[i].player = new Podcastplayer(podcasts[i]);
                        }
                        break;
                }

                // add new autoload data
                if(r['autoload'])
                {
                    this.targetContainer.dataset.start = r['start'].toString();
                    this.start_observing();
                }
            }).catch(error => {
                console.error(error);
            })
        }
    }

    insert_news(r)
    {
        if(Array.isArray(r['tiles']))
        {
            for(let i=0; i<r['tiles'].length; i++)
            {
                let section = this.targetContainer.querySelector('.w__module--tiles[data-year-month="' +
                    r['tiles'][i]['yearMonth'] + '"]');

                if(!section)
                {
                    // headline year + month
                    const h2 = document.createElement('h2');
                    h2.classList.add('w__news--section-headline');
                    h2.textContent = r['tiles'][i]['yearMonth'].substring(0, 4);
                    const span = document.createElement('span');
                    span.classList.add('w__news--section-month');
                    span.textContent = r['tiles'][i]['month'];
                    h2.insertAdjacentElement('afterbegin', span);

                    // tile container
                    const div = document.createElement('div');
                    div.className = 'w__tile--container w__tile--container-news';

                    // section
                    section = document.createElement('section');
                    section.classList.add('w__module--tiles');
                    section.dataset.yearMonth = r['tiles'][i]['yearMonth'];
                    section.appendChild(h2);
                    section.appendChild(div);

                    // add new section to target container
                    this.targetContainer.appendChild(section);
                }

                section.querySelector('.w__tile--container')
                    .insertAdjacentHTML('beforeend', r['tiles'][i]['tile']);
            }
        }
    }

    insert_tiles(tiles)
    {
        if(Array.isArray(tiles))
        {
            for(let i=0; i<tiles.length; i++)
            {
                this.targetContainer.insertAdjacentHTML('beforeend',tiles[i]);
            }
        }
    }
}